import { useReducer } from "react";
import { capitalizeText, handleChange } from "../utility/utils";

const initValues = (value = "") => {
  return {
    value: value,
    touched: false,
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    case "INPUT": {
      return {
        ...state,
        value: action.value,
      };
    }
    case "TOUCHED": {
      return {
        ...state,
        touched: true,
      };
    }
    case "RESET": {
      return {
        ...state,
        value: action.initValue,
      };
    }
  }
};

const useInput = (validate, classes, initValue, filter = true) => {
  const [state, dispatch] = useReducer(reducer, initValues(initValue));

  const isValid = validate(state.value);
  const hasError = !isValid && state.touched;

  const changeHandler = (e) => {
    if (filter) {
      dispatch({ type: "INPUT", value: capitalizeText(handleChange(e)) });
    }

    dispatch({ type: "INPUT", value: e.target.value });
  };

  const blurHandler = () => {
    dispatch({ type: "TOUCHED" });
  };

  const reset = () => {
    dispatch({ type: "RESET", initValue });
  };

  const inputClasses = hasError
    ? `${classes.control} ${classes.invalid}`
    : classes.control;

  return {
    value: state.value,
    isValid,
    changeHandler,
    blurHandler,
    inputClasses,
    reset,
  };
};

export default useInput;
